<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="会员等级" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-button type="success" icon="el-icon-plus" @click="add">新增等级</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="等级名称" prop="name" width="140"></el-table-column>
        <el-table-column label="折扣" prop="discount" width="100"></el-table-column>
        <el-table-column label="升级门槛" prop="threshold" width="120"></el-table-column>
        <el-table-column label="权益说明" prop="benefits"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="等级名称" required><el-input v-model="form.name"></el-input></el-form-item>
        <el-form-item label="折扣"><el-input v-model="form.discount" placeholder="如 0.95"></el-input></el-form-item>
        <el-form-item label="升级门槛"><el-input v-model.number="form.threshold" type="number"></el-input></el-form-item>
        <el-form-item label="权益说明"><el-input v-model="form.benefits" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      list: [],
      show: false,
      dialogTitle: '',
      form: {}
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.http.get('/memberLevels').then(r => {
        if (r.data.status === 200) this.list = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增等级'
      this.form = { name: '', discount: 1, threshold: 0, benefits: '' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑等级'
      this.form = Object.assign({}, row)
      this.show = true
    },
    save () {
      if (!this.form.name) { this.$message.warning('名称必填'); return }
      if (this.form.id) {
        this.$axios.put(`/memberLevels/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/memberLevels', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/memberLevels/${id}`, () => this.getData())
    }
  }
}
</script>
